import { LoadingSpinner } from "components/LoadingSpinner";
import { useGetAnalyticsUrlQuery } from "store/queries/analytics";

export function Analytics({ accountId }: { accountId?: string }) {
  const { data: analyticsData, isLoading } = useGetAnalyticsUrlQuery(
    { accountId: accountId as string },
    { skip: !accountId }
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="w-full flex flex-column gap-2">
      <div
        style={{
          width: "100%",
          height: "2800px",
          padding: "0",
          margin: "0",
        }}
      >
        {analyticsData?.data?.iframeUrl && (
          <iframe
            src={analyticsData.data.iframeUrl}
            frameBorder="0"
            width="1400"
            height="2800"
            title="Analytics"
          />
        )}
      </div>
    </div>
  );
}
